import { useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { userSlice } from "../../redux/user/userSlice";
import { useDragParentGroup } from "./useDragParentGroup";
import { FIRST_SCENE_GROUP_ID } from "./schemeLayout";

const { showDialog } = userSlice;

const GroupNode = (props) => {
  const { selected, data } = props;
  const isSceneSelected = selected || data?.isSceneSelected;
  const isFirstScene = props.id === FIRST_SCENE_GROUP_ID;
  const dispatch = useDispatch();
  const startGroupDrag = useDragParentGroup(props.id);

  const handleDeleteClick = (event) => {
    event.stopPropagation();
    dispatch(
      showDialog({
        type: "delete-scene",
        data: { groupId: props.id },
      })
    );
  };

  return (
    <div
      className={`scheme-group-shell${
        isSceneSelected ? " scheme-group-shell--active" : ""
      }${isFirstScene ? " scheme-group-shell--first" : ""}`}
    >
      <div
        className="scheme-group-drag-surface scheme-group-drag-handle"
        onPointerDown={startGroupDrag}
        title="Перетащите карточку"
      />

      <div
        className="scheme-group-header scheme-group-drag-handle"
        title="Перетащите карточку"
      >
        <DragIndicatorIcon className="scheme-group-drag-icon" fontSize="small" />
        {isSceneSelected && !isFirstScene && (
          <DeleteIcon
            className="scheme-group-delete nodrag nopan"
            fontSize="small"
            onPointerDown={(event) => event.stopPropagation()}
            onClick={handleDeleteClick}
          />
        )}
      </div>
    </div>
  );
};

export default GroupNode;
